module.exports = __webpack_public_path__ + "static/group3_4-fc722c1e9c364e831e3a7dabfe6d1d22.webp";